module.exports = __webpack_public_path__ + "static/media/plus_disable.45183d65.svg";